import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import NotYetOpen from "@/components/NotYetOpen.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ActiveView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NotYetOpen, { data: "暂未开放，敬请期待!" }))
}
}

})